import React from "react";

import { Module } from "@com.mgmtp.a12.client/client-core/lib/core/application";
import { View } from "@com.mgmtp.a12.client/client-core/lib/core/view";

import { AuxiliaryOverviewEngine } from "../../component/auxiliaryOverviewEngine/overviewEngine";

import { WiedervorlageInitialiser } from "./dataProvider";
import {
	closeWiedervorlagenMiddleware,
	syncWiedervorlagenMiddleware,
	validateWiedervorlageBeforeEditMiddleware
} from "./middlewares";
import { wiedervorlageSagas } from "./sagas";

const wiedervorlageModule = (): Module => ({
	id: "wiedervorlageModule",
	views: () => viewComponentProvider,
	sagas: () => wiedervorlageSagas,
	dataProviders: () => [WiedervorlageInitialiser],
	middlewares: () => [
		closeWiedervorlagenMiddleware,
		validateWiedervorlageBeforeEditMiddleware,
		syncWiedervorlagenMiddleware
	]
});

const components: { [name: string]: React.ComponentType<View> | undefined } = {
	WiedervorlagenOverviewEngine: AuxiliaryOverviewEngine
};

function viewComponentProvider(name: string) {
	return components[name];
}

export default wiedervorlageModule;
